/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import PropTypes from 'prop-types';
import FormFields from "./formField";
import { getValidationRules } from "../../utils/Validation/GetValidationRule";
import { ValidateAll, Validate } from "../../utils/Validation/Validation";

const FormCreator = forwardRef((props, ref) => {

  // const [isFieldRequired, setIsFieldRequired] = useState(false);
  const [formData, setFormData] = useState(props.initialState);
  const [validState, setValidState] = useState({
    isValid: true,
    error: {},
  });
  const [validationRules, setValidationRules] = useState({});

  useEffect(() => {
    if (props.formSetting && props.formSetting.isViewOnly) {
      const valRule = getValidationRules(props.formFields);
      setValidationRules(valRule);
      return;
    }
    const valRule = getValidationRules(props.formFields);
    setValidationRules(valRule);
    // updateIsRequiredFlag(valRule);
  }, [props.formFields]);

  // reset the initial state 
  useEffect(() => {
    setFormData(props.initialState);
    setValidState({
      isValid: true,
      error: {},
    });

    return () => {

    }
  }, [props.initialState]);

  useImperativeHandle(
    ref,
    () => {
      return {
        getFormData: () => {
          if (isValidForm())

            return formData;
        },
      };
    },
    [formData, validState, validationRules],
  );

  const isValidForm = () => {
    const validation = ValidateAll(formData, validationRules);
    if (!validation.isValid) {
      setValidState(validation);

    }
    return validation.isValid;
  };


  // Checks if the validation exists if so then the required field will show a astrisk(*)
  // THE CODE GOES HERE

  // const checkIsRequired = (fields) => {
  //   fields.forEach(field => {
  //     if(field.validation && field.validation !== null) {
  //       setIsFieldRequired(true)
  //     }
  //   })
  // }

  // const updateIsRequiredFlag = (validationRules) => {
  //   const updatedFormFields = props.formFields.map(field => {
  //     const hasValidation = validationRules[field.dataField] && validationRules[field.dataField].length > 0;
  //     return {
  //       ...field,
  //       isRequired: hasValidation
  //     };
  //   });
  //   setFormData(updatedFormFields);
  // };


  const handleStateChange = (updatedData) => {
    setFormData(updatedData);
  };

  const handleOnValidateField = (dataField) => {

    let validationObj = { ...validState }

    if (validationRules[dataField]) {
      const validation = Validate(formData, validationRules, dataField);
      if (!validation.isValid) {

        validationObj.error[dataField] = validation.error[dataField];
        validationObj.isValid = false;
        setValidState(validationObj);
      }
      else {

        if (validationObj.error[dataField]) {
          delete validationObj.error[dataField];
          setValidState(validationObj);

        }

      }
    }
  };

  const onActionHandle = (action, data) => {
    if (props.onActionChange[action]) {
      props.onActionChange[action](data);
    }
  }
  return (
    <>
      {props.formFields ? (
        <FormFields
          fields={props.formFields}
          formData={formData}
          validState={validState}
          onActionChange={onActionHandle}
          onFormStateChange={handleStateChange}
          onUpdateValidation={handleOnValidateField}
          formSetting={props.formSetting}
          fieldValiadtionRules={validationRules}
        />
      ) : (
        <div>No fields configured</div>
      )}
    </>
  );
});

FormCreator.propTypes = {
  name: PropTypes.string,
  initialState: PropTypes.object,
  formFields: PropTypes.array,
  onFormDataUpdate: PropTypes.func,
};

export default FormCreator;